var cov_po7dlo0r7 = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Form/formButton.tsx",
      hash = "669a63296ef673311ed413d2ffd5908944833605",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Form/formButton.tsx",
    statementMap: {
      "0": {
        start: {
          line: 8,
          column: 2
        },
        end: {
          line: 44,
          column: 3
        }
      },
      "1": {
        start: {
          line: 14,
          column: 8
        },
        end: {
          line: 14,
          column: 20
        }
      },
      "2": {
        start: {
          line: 16,
          column: 8
        },
        end: {
          line: 16,
          column: 54
        }
      },
      "3": {
        start: {
          line: 17,
          column: 8
        },
        end: {
          line: 17,
          column: 54
        }
      },
      "4": {
        start: {
          line: 21,
          column: 8
        },
        end: {
          line: 21,
          column: 24
        }
      },
      "5": {
        start: {
          line: 25,
          column: 8
        },
        end: {
          line: 28,
          column: 9
        }
      },
      "6": {
        start: {
          line: 26,
          column: 23
        },
        end: {
          line: 26,
          column: 72
        }
      },
      "7": {
        start: {
          line: 27,
          column: 10
        },
        end: {
          line: 27,
          column: 49
        }
      },
      "8": {
        start: {
          line: 30,
          column: 8
        },
        end: {
          line: 30,
          column: 52
        }
      },
      "9": {
        start: {
          line: 30,
          column: 32
        },
        end: {
          line: 30,
          column: 52
        }
      },
      "10": {
        start: {
          line: 34,
          column: 48
        },
        end: {
          line: 34,
          column: 58
        }
      },
      "11": {
        start: {
          line: 35,
          column: 21
        },
        end: {
          line: 35,
          column: 86
        }
      },
      "12": {
        start: {
          line: 37,
          column: 8
        },
        end: {
          line: 41,
          column: 9
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 7,
            column: 15
          },
          end: {
            line: 7,
            column: 16
          }
        },
        loc: {
          start: {
            line: 8,
            column: 2
          },
          end: {
            line: 44,
            column: 3
          }
        },
        line: 8
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 13,
            column: 6
          },
          end: {
            line: 13,
            column: 7
          }
        },
        loc: {
          start: {
            line: 13,
            column: 42
          },
          end: {
            line: 18,
            column: 7
          }
        },
        line: 13
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 20,
            column: 6
          },
          end: {
            line: 20,
            column: 7
          }
        },
        loc: {
          start: {
            line: 20,
            column: 35
          },
          end: {
            line: 22,
            column: 7
          }
        },
        line: 20
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 24,
            column: 6
          },
          end: {
            line: 24,
            column: 7
          }
        },
        loc: {
          start: {
            line: 24,
            column: 39
          },
          end: {
            line: 31,
            column: 7
          }
        },
        line: 24
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 33,
            column: 6
          },
          end: {
            line: 33,
            column: 7
          }
        },
        loc: {
          start: {
            line: 33,
            column: 15
          },
          end: {
            line: 42,
            column: 7
          }
        },
        line: 33
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 25,
            column: 8
          },
          end: {
            line: 28,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 25,
            column: 8
          },
          end: {
            line: 28,
            column: 9
          }
        }, {
          start: {
            line: 25,
            column: 8
          },
          end: {
            line: 28,
            column: 9
          }
        }],
        line: 25
      },
      "1": {
        loc: {
          start: {
            line: 30,
            column: 8
          },
          end: {
            line: 30,
            column: 52
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 30,
            column: 8
          },
          end: {
            line: 30,
            column: 52
          }
        }, {
          start: {
            line: 30,
            column: 8
          },
          end: {
            line: 30,
            column: 52
          }
        }],
        line: 30
      },
      "2": {
        loc: {
          start: {
            line: 35,
            column: 21
          },
          end: {
            line: 35,
            column: 86
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 35,
            column: 21
          },
          end: {
            line: 35,
            column: 36
          }
        }, {
          start: {
            line: 35,
            column: 41
          },
          end: {
            line: 35,
            column: 85
          }
        }],
        line: 35
      },
      "3": {
        loc: {
          start: {
            line: 35,
            column: 41
          },
          end: {
            line: 35,
            column: 85
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 35,
            column: 64
          },
          end: {
            line: 35,
            column: 73
          }
        }, {
          start: {
            line: 35,
            column: 76
          },
          end: {
            line: 35,
            column: 85
          }
        }],
        line: 35
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _objectWithoutProperties from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Form/formButton.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import Button from '../Button';
import { getParent, dispatchEvent } from '../utils/dom/element';
import { formConsumer } from './formContext';
export default (function (htmlType) {
  var _temp;

  cov_po7dlo0r7.f[0]++;
  cov_po7dlo0r7.s[0]++;
  return formConsumer(['disabled'], (_temp =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(FormButton, _PureComponent);

    var _super = _createSuper2(FormButton);

    function FormButton(props) {
      var _this;

      _classCallCheck(this, FormButton);

      cov_po7dlo0r7.f[1]++;
      cov_po7dlo0r7.s[1]++;
      _this = _super.call(this, props);
      _this.button = void 0;
      cov_po7dlo0r7.s[2]++;
      _this.bindElement = _this.bindElement.bind(_assertThisInitialized(_this));
      cov_po7dlo0r7.s[3]++;
      _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
      return _this;
    }

    _createClass(FormButton, [{
      key: "bindElement",
      value: function bindElement(el) {
        cov_po7dlo0r7.f[2]++;
        cov_po7dlo0r7.s[4]++;
        this.button = el;
      }
    }, {
      key: "handleClick",
      value: function handleClick(e) {
        cov_po7dlo0r7.f[3]++;
        cov_po7dlo0r7.s[5]++;

        if (htmlType === 'button') {
          cov_po7dlo0r7.b[0][0]++;
          var form = (cov_po7dlo0r7.s[6]++, getParent(this.button, 'form'));
          cov_po7dlo0r7.s[7]++;
          dispatchEvent(form, 'submit', e.target);
        } else {
          cov_po7dlo0r7.b[0][1]++;
        }

        cov_po7dlo0r7.s[8]++;

        if (this.props.onClick) {
          cov_po7dlo0r7.b[1][0]++;
          cov_po7dlo0r7.s[9]++;
          this.props.onClick();
        } else {
          cov_po7dlo0r7.b[1][1]++;
        }
      }
    }, {
      key: "render",
      value: function render() {
        cov_po7dlo0r7.f[4]++;

        var _ref = (cov_po7dlo0r7.s[10]++, this.props),
            children = _ref.children,
            onClick = _ref.onClick,
            other = _objectWithoutProperties(_ref, ["children", "onClick"]);

        var type = (cov_po7dlo0r7.s[11]++, (cov_po7dlo0r7.b[2][0]++, this.props.type) || (cov_po7dlo0r7.b[2][1]++, htmlType === 'reset' ? (cov_po7dlo0r7.b[3][0]++, 'default') : (cov_po7dlo0r7.b[3][1]++, 'primary')));
        cov_po7dlo0r7.s[12]++;
        return (
          /*#__PURE__*/
          React.createElement(Button, Object.assign({}, other, {
            type: type,
            htmlType: htmlType,
            onRef: this.bindElement,
            onClick: this.handleClick,
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 38,
              columnNumber: 11
            }
          }), children)
        );
      }
    }]);

    return FormButton;
  }(PureComponent), _temp));
});